
import {Vue, Component} from 'vue-property-decorator';
import {isEmail, isPhone, nil} from '@/common';
@Component({
    components: {
    },
})
export default class ValidationMixin extends Vue {
    public requiredRule = (v, name = 'This Field', falsyCounts = true) => !nil(v, falsyCounts) || `${name} is required`;
    public minimumLengthRule = (v, length, name= 'This Field') => !nil(v, true) && v.length >= length || `${name} must be at least ${length} characters long`;
    public emailRule = (v) => isEmail(v) || 'Invalid Email';
    public phoneRule = (v) => isPhone(v) || 'Invalid Phone Number';
    public requiresAtLeastOne = (v, name) => v.length > 0 || `At least one ${name} is required`;
}
